import { render, staticRenderFns } from "./jdePop.vue?vue&type=template&id=24394f74&scoped=true&"
import script from "./jdePop.vue?vue&type=script&lang=js&"
export * from "./jdePop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24394f74",
  null
  
)

export default component.exports